import { __awaiter, __generator } from "tslib";
import { OfficeWorkload } from '@office-start/officehome-types';
var launchUserPreferencesFuncs;
export function getUserPreferenceService(workload) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(workload === OfficeWorkload.Embed)) return [3 /*break*/, 2];
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "teamsservicefile" */ './teamsServiceFile').then(function (module) { return ({
                            getContentLaunchPreference: module.getContentLaunchPreference,
                        }); })];
                case 1:
                    //create teams service file. In that file, similar to hwaLAunchFile. REturn the service object,
                    launchUserPreferencesFuncs = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, launchUserPreferencesFuncs];
            }
        });
    });
}
//# sourceMappingURL=getUserPreferencesFunctions.js.map